// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Incident API
 * API to get incident information
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HandlerIncidentResponse } from './HandlerIncidentResponse';
import {
  HandlerIncidentResponseFromJSON,
  HandlerIncidentResponseFromJSONTyped,
  HandlerIncidentResponseToJSON,
  HandlerIncidentResponseToJSONTyped,
} from './HandlerIncidentResponse';

/**
 *
 * @export
 * @interface HandlerIncidentListResponse
 */
export interface HandlerIncidentListResponse {
  /**
   *
   * @type {Array<HandlerIncidentResponse>}
   * @memberof HandlerIncidentListResponse
   */
  incidents?: Array<HandlerIncidentResponse>;
}

/**
 * Check if a given object implements the HandlerIncidentListResponse interface.
 */
export function instanceOfHandlerIncidentListResponse(
  value: object,
): value is HandlerIncidentListResponse {
  return true;
}

export function HandlerIncidentListResponseFromJSON(
  json: any,
): HandlerIncidentListResponse {
  return HandlerIncidentListResponseFromJSONTyped(json, false);
}

export function HandlerIncidentListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlerIncidentListResponse {
  if (json == null) {
    return json;
  }
  return {
    incidents:
      json['incidents'] == null
        ? undefined
        : (json['incidents'] as Array<any>).map(
            HandlerIncidentResponseFromJSON,
          ),
  };
}

export function HandlerIncidentListResponseToJSON(
  json: any,
): HandlerIncidentListResponse {
  return HandlerIncidentListResponseToJSONTyped(json, false);
}

export function HandlerIncidentListResponseToJSONTyped(
  value?: HandlerIncidentListResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    incidents:
      value['incidents'] == null
        ? undefined
        : (value['incidents'] as Array<any>).map(HandlerIncidentResponseToJSON),
  };
}
